// Component Name:  Actionable pop-up messages
// Author: Lavanya S
// Platform: 
// OS: Windows
// IDE: Visual Studio Code
// Reference: Original
// Date: 15-07-2024
// Description:  This component is designed to handle the display of pop up and 
              // requires positive / negative affirmation by the user, 
              // the background screen will be overlaid
              // user has to click on either "Ok" or "cancel" to come out of this pop up 
// Props: 1. index to dynamically handle the popup position on the screen
        // 2. theme to switch color between dark and light mode
        // 3. popUpData is an Object, contains id(current time), popup type, popup Message
       // 4. onClose function
// Dependencies: React library
// Interfaces: props
// Maintenance History: 1.0 First Version

// [20-05-2025] Integrated in CMS
import React, { useState } from "react";
import LK_Information_Light from "../../assets/images/infobar/LK_Information_Light.svg";
import LK_Information_Dark from "../../assets/images/infobar/LK_Information_Dark.svg";
import { connect } from "react-redux";

const ActionablePopUp = (props) => {
  const { index, theme, popUpData, onClose,layoutType } = props
  const [ishoverOK, setIsHoverOK] = useState(false);
  const [ishoverCancel, setIsHoverCancel] = useState(false);

  const bgColor = {
    Regular: "#0766F6",
    Success: "#00943D",
    Failure: "#DC272D",
    Reminder: "#EE8C19",
    Warning: "#FFD000",
    Error: "#DC272D",
  };
  const styles = {
    container: {},
    popupContainer: {
      backgroundColor: theme ? "#1E1E1E" : "#FFFFFF",
      zIndex: "10",
      padding: "3px",
      borderTopLeftRadius: "42px",
      borderTopRightRadius: "42px",

      marginTop: "10px",
      position: "absolute",
      minHeight: "199px",
      height:"auto",
      width: layoutType === "vertical" ? "488px" : "95%",
      top: `${index * 30 + 22}%`,
      left: "50%",
      transform: "translate(-50%,-50%)",
    },
    toastMessageContainer: {
      backgroundColor: bgColor[popUpData.type],
      borderRadius: "45px",
      padding: "4px",
      height: "80px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: "5px",
    },
    infoIcon: {
      width: "31px",
      height: "31px",
    },
    toastMessage: {
      color: popUpData?.type === "Warning" ? "#3C3C3C" : "#FFFFFF",
      fontSize: "20px",
      fontWeight:"700"
    },
    affirmation: {
      marginBottom: "15px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    },

    affirmationMessage: {
      fontSize: "14px",
      fontWeight:"700",
      margin: "20px 0",
      color: theme ? "#FFFFFF" : "#3C3C3C",
    },
    positiveAffirmationBtn: {
      borderRadius: "50px",
      height: "35px",
      width: "137px",
      backgroundColor: ishoverOK ? "transparent" : "#005C8E",
      border: ishoverOK
        ? theme
          ? "2px solid #FFFFFF"
          : "2px solid #008CD7"
        : "none",
      color: ishoverOK ? (theme ? "#FFFFFF" : "#008CD7") : "#FFFFFF",
      fontSize: "16px",
      margin: "0 10px",
      fontWeight: "700",
    },
    negativeAffirmationBtn: {
      height: "35px",
      width: "137px",
      borderRadius: "50px",
      fontSize: "16px",
      fontWeight: ishoverCancel ? "700" : "400",
      border: ishoverCancel
        ? (theme
          ? "2px solid #FFFFFF"
          : "2px solid #008CD7")
        : "1px solid #C1C1C1",
      color: ishoverCancel ? (theme ? "#FFFFFF" : "#008CD7") : "#7E7E7E",
      backgroundColor: "transparent",
      margin: "0 10px",
    },
  };
  return (
    <div style={styles.container}>
      <div style={styles.popupContainer}>
        <div style={styles.toastMessageContainer}>
          <img src={popUpData?.type === "Warning" ? LK_Information_Dark : LK_Information_Light} style={styles.infoIcon} />
          <h4 style={styles.toastMessage}>{popUpData?.type.toUpperCase()} !</h4>
        </div>
        <div style={styles.affirmation}>
          <span style={styles.affirmationMessage}>{popUpData?.affirmationMsg}</span>
          <div>
            <button
              style={styles.positiveAffirmationBtn}
              onClick={()=>onClose(true)}
              onMouseOver={() => setIsHoverOK(true)}
              onMouseLeave={() => setIsHoverOK(false)}
            >
              OK
            </button>
            <button
              style={styles.negativeAffirmationBtn}
              onClick={()=>onClose(false)}
              onMouseOver={() => setIsHoverCancel(true)}
              onMouseLeave={() => setIsHoverCancel(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  layoutType: state.Layout.layoutType,
});

export default connect(mapStateToProps)(ActionablePopUp);
